const styles = (theme) => ({
  moduleHeader: {
    color: theme.HeaderSelectedText,
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    padding: "10px 20px",
    borderBottom: "0px",
  },
  headerActionIcons: {
    display: "flex",
    float: "right",
  },
  contentContainer: {
    padding: "5px 18px 32px 18px",
    height: `calc(100% - 42px)`,
    boxSizing: "border-box",
    clear: "right",
  },
  headerIconStyles: {
    padding: "5px 10px",
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: "pointer",
    color: theme.iconColor,
    display: "flex",
    alignItems: "center",
  },
  anchorPointAutoZoom: {
    float: "right",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "19px",
    [theme.breakpoints.down("md")]: {
      padding: "3px 8px",
    },
  },
  subModule: {
    height: "100%",
    width: "100%",
  },
  showAliasesButton: {
    color: theme.iconColor,
    borderColor: theme.iconColor,
    fontSize: theme.textFontSize,
    "&$disabledButton": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8,
    },
  },
  disabledButton: {},
  buttonText: {
    marginLeft: 8,
  },
  groupIcon: {
    fontSize: 20,
    transform: "scale(-1,1)",
  },
  buttonContainer: {
    display: "flex",
    borderRight: `1px solid ${theme.AppBGColor}`,
    paddingRight: 8,
  },
  customSearchWidth200: {
    minWidth: 200,
  }
});

export default styles;
